// extracted by mini-css-extract-plugin
export default {"collapse":"UbZtJc"};